import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'

const StatsCard = ({ title, value, icon, color, format, trend }) => {
  const formatValue = (val, fmt) => {
    switch (fmt) {
      case 'currency': return `Rp ${Math.abs(val).toLocaleString('id-ID')}`
      case 'percentage': return `${val.toFixed(1)}%`
      case 'decimal': return val.toFixed(2)
      default: return val.toString()
    }
  }

  const getColorStyles = (c) => {
    const map = {
      blue: 'bg-blue-500/10 text-blue-500',
      green: 'bg-emerald-500/10 text-emerald-500',
      red: 'bg-red-500/10 text-red-500',
      purple: 'bg-violet-500/10 text-violet-500'
    }
    return map[c] || map.blue
  }

  return (
    <motion.div 
      whileHover={{ scale: 1.02 }}
      className="lux-card p-5 flex items-center justify-between group cursor-pointer"
    >
      <div className="flex items-center space-x-4">
        <div className={`p-3.5 rounded-2xl ${getColorStyles(color)} group-hover:scale-110 transition-transform duration-300`}>
          <SafeIcon icon={icon} className="h-6 w-6" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</p>
          <div className="flex items-center space-x-2">
            <p className="text-xl font-bold text-gray-900 dark:text-white">
              {value < 0 && format === 'currency' ? '-' : ''}
              {formatValue(value, format)}
            </p>
            {trend && (
              <span className="text-xs font-bold text-green-500 bg-green-500/10 px-1.5 py-0.5 rounded">
                {trend}
              </span>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default StatsCard